// extracted by mini-css-extract-plugin
export default {"list":"Main_list__3Pj+L"};